export const citiesMap = {
  austin: "Austin, TX",
  brooklyn: "Brooklyn, NY",
  dunedin: "Dunedin, FL",
  dallas: "Dallas, TX",
  oak_ridge_north: "Oak Ridge North, TX",
  houston: "Houston, TX",
  jupiter: "Jupiter, FL",
  chicago: "Chicago, IL",
  tampa: "Tampa Bay, FL",
  lakeland: "Lakeland, FL",
  scottsdale: "Scottsdale, AZ",
  southlake: "Southlake, TX",
  boca_raton: "Boca Raton, FL",
  los_angeles: "Los Angeles, CA",
  lake_park: "Lake Park, FL",
  rosemont: "Rosemont, IL",
  new_york: "New York, NY",
  irving: "Irving, TX",
  stpetersburg: "St. Petersburg, FL",
  riverview: "Riverview, FL",
  phoenix: "Phoenix, AZ",
  boynton_back: "Boynton Beach, FL",
  west_palm_beach: "West Palm Beach, FL",
  delray_beach: "Delray Beach, FL",
  georgetown: "Georgetown, TX",
  san_antonio: "San Antonio, TX",
  friendswood: "Friendswood, TX",
  gilbert: "Gilbert, AZ",
  mesa: "Mesa, AZ",
  round_rock: "Round Rock, TX",
  palm_beach: "Palm Beach, FL",
  dfw: "DFW, TX",
  albuquerque: "Albuquerque, NM",
  fort_collins: "Fort Collins, CO",
  santa_monica: "Santa Monica, CA",
  tomball: "Tomball, TX",
  katy: "Katy, TX",
  stafford: "Stafford, TX",
  montgomery: "Montgomery, TX",
  college_station: "College Station, TX",
  spring: "Spring, TX",
  brea: "Brea, CA",
  anaheim: "Anaheim, CA",
  boynton_beach: "Boynton Beach, FL",
  breckenridge: "Breckenridge, CO",
  castle_rock: "Castle Rock, CO",
  clearwater: "Clearwater, FL",
  costa_mesa: "Costa Mesa, CA",
  denver: "Denver, CO",
  englewood: "Englewood, CO",
  fountain_valley: "Fountain Valley, CA",
  irvine: "Irvine, CA",
  laguna_beach: "Laguna Beach, CA",
  newport_beach: "Newport Beach, CA",
  orange: "Orange, CA",
  palm_beach_gardens: "Palm Beach Gardens, FL",
  rancho_santa_margarita: "Rancho Santa Margarita, CA",
  safety_harbor: "Safety Harbor, FL",
  santa_ana: "Santa Ana, CA",
  vail: "Vail, CO",
  yorba_linda: "Yorba Linda, CA",
  cedar_park: "Cedar Park, TX",
  fredricksberg: "Fredricksberg, TX",
  leander: "Leander, TX",
  arcadia: "Arcadia, CA",
  calabases: "Calabases, CA",
  downey: "Downey, CA",
  pasadena: "Pasadena, CA",
  palm_desert: "Palm Desert, CA",
  palm_springs: "Palm Springs, CA",
  san_francisco: "San Francisco, CA",
  chandler: "Chandler, AZ",
  tempe: "Tempe, AZ",
  queens: "Queens, NY",
  beverly_hills: "Beverly Hills, CA",
  pacific_palisades: "Pacific Palisades, CA",
  calabasas: "Calabasas, CA",
  fredericksburg: "Fredericksburg, TX",
  princeton: "Princeton, IL",
  jacksonville: "Jacksonville, FL",
  buffalo: "Buffalo, NY",
  plano: "Plano, TX",
  fort_worth: "Fort Worth, TX",
  mckinney: "McKinney, TX",
  richardson: "Richardson, TX",
  colleyville: "Colleyville, TX",
  farmers_branch: "Farmers Branch, TX",
  frisco: "Frisco, TX",
  oklahoma_city: "Oklahoma City, OK",
  alpharetta: "Alpharetta, GA",
};
